import { TooltipProvider } from "@radix-ui/react-tooltip";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import * as Sentry from "@sentry/react";
import { GlobalLoad } from "components/global-load/global-load.tsx";
import { Modal } from "components/modal/index.tsx";
import { ConfirmationAlert } from "components/confirmation-alert/index.tsx";
import { SidebarProvider } from "components/ui/sidebar.tsx";
import { Provider } from "react-redux";
import { BeautifulToaster } from "./components/ui/toaster.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry.ts";
import App from "./routes/index.tsx";
import { store } from "./store/index.ts";
import { KeycloakProviderWrapper } from "./context/kc.tsx";
import { featureFlags } from "./config/feature-flag.ts";
import { getPageTitle } from "./utils/environment.ts";

initSentry();

// Define o título da página baseado no ambiente
document.title = getPageTitle();

const root = createRoot(document.getElementById("root")!);

const AppContent = (
  <StrictMode>
    <TooltipProvider>
      <Provider store={store}>
        <SidebarProvider>
          <Sentry.ErrorBoundary
            fallback={<p>Ocorreu um erro. Tente novamente mais tarde.</p>}
          >
            <App />
          </Sentry.ErrorBoundary>
        </SidebarProvider>
        <BeautifulToaster />
        <GlobalLoad />
        <Modal />
        <ConfirmationAlert />
      </Provider>
    </TooltipProvider>
  </StrictMode>
);

root.render(
  featureFlags.USE_KEYCLOAK ? (
    <KeycloakProviderWrapper>{AppContent}</KeycloakProviderWrapper>
  ) : (
    AppContent
  )
);
